import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/views/dashboard/Dashboard'
import Home from '@/views/dashboard/pages/home/Home.vue'
import Project from '@/views/dashboard/pages/project/Project.vue'
import Projects from '@/views/dashboard/pages/project/Projects.vue'
import Users from '@/views/dashboard/pages/users/Users.vue'
import MyUsers from '@/views/dashboard/pages/users/MyUsers.vue'

import User from '@/views/dashboard/pages/users/User.vue'

import Enterprises from '@/views/dashboard/pages/enterprise/Enterprises.vue'

import Enterprise from '@/views/dashboard/pages/enterprise/Enterprise.vue'
import Devices from '@/views/dashboard/pages/devices/Devices.vue'
import Device from '@/views/dashboard/pages/devices/Device.vue'
import Templates from '@/views/dashboard/pages/templates/Templates.vue'

import Fields from '@/views/dashboard/pages/fields/Fields.vue'
import Deal from '@/views/dashboard/pages/deals/Deal.vue'
import Deals from '@/views/dashboard/pages/deals/Deals.vue'
import Contacts from '@/views/dashboard/pages/contacts/Contacts.vue'
import Contact from '@/views/dashboard/pages/contacts/Contact.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      meta:{ 
         title:'Login'
       },
      component: () => import(/* webpackChunkName: "login" */ '@/views/dashboard/pages/login/Login.vue')
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
    
        {
          name: 'templates',
          path: '/templates',
          component: Templates,
        },
        {
          name: 'home',
          path: '',
          component: Home,
        },
        {
          name: 'contacts',
          path: '/contacts',
          component: Contacts,
        },
        {
          name: 'contact',
          path: '/contact',
          component: Contact,
        },
        {
          name: 'contact',
          path: '/contact/:contactId',
          props:true,
          component: Contact,
        },
        {
          name: 'deal',
          path: '/deal',
          component: Deal,
        },
        
        {
          name: 'deal',
          path: '/deal/:dealId',
          props:true,
          component: Deal,
        },
             
        {
          name: 'deal',
          path: '/deal/:dealId/newproject',
          props:true,
          component: Project,
        },
        {
          name: 'deals',
          path: '/deals',
          component: Deals,
        },
        {
          name: 'enterprise',
          path: '/enterprise',
          component: Enterprise,
        },
        {
          name: 'devices',
          path: '/devices',
          component: Devices,
        },
        {
          path: '/device/:deviceId',
          name: 'device',
          props: true,
          component: Device
        },
        {
          path: '/device',
          name: 'device',
          props: true,
          component: Device
        },

        {
          path: '/fields',
          name: 'fields',
          props: true,
          component: Fields
        },

        {
          name: 'dashboard',
          path: '/dashboard',
          component: Dashboard,
        },
        {
          name: 'project',
          path: '/project/:projectId',
          props:true,
          component: Project,
        },
        {
          path: '/project',
          name: 'Proposta',
         // props: true,
          component: Project
        },
        {
          name: 'projects',
          path: '/projects',
   
          component: Projects,
        },
        {
          name: 'user',
          path: '/user',
   
          component: User,
        },
        {
          name: 'users',
          path: '/users',
   
          component: Users,
        },
        {
          name: 'myusers',
          path: '/myusers',
          component: MyUsers,
        },
        {
          name: 'enterprises',
          path: '/enterprises',
   
          component: Enterprises,
        },

        // Pages
        {
          name: 'User Profile',
          path: 'pages/user',
          component: () => import('@/views/dashboard/pages/UserProfile'),
        },
        {
          name: 'Notifications',
          path: 'components/notifications',
          component: () => import('@/views/dashboard/component/Notifications'),
        },
        {
          name: 'Icons',
          path: 'components/icons',
          component: () => import('@/views/dashboard/component/Icons'),
        },
        {
          name: 'Typography',
          path: 'components/typography',
          component: () => import('@/views/dashboard/component/Typography'),
        },
        // Tables
        {
          name: 'Regular Tables',
          path: 'tables/regular-tables',
          component: () => import('@/views/dashboard/tables/RegularTables'),
        },
        // Maps
        {
          name: 'Google Maps',
          path: 'maps/google-maps',
          component: () => import('@/views/dashboard/maps/GoogleMaps'),
        },
        // Upgrade
        {
          name: 'Upgrade',
          path: 'upgrade',
          component: () => import('@/views/dashboard/Upgrade'),
        },
      ],
    },
  ],
})
